module.exports = __webpack_public_path__ + "img/home.856959b4.svg";